import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/kazhavda-logo-white.png";
import "./FloatingNavbarDesktop.css";

const isLinkActive = (to, currentPath) => {
  if (to === "/organizer") {
    return currentPath.startsWith("/organizer");
  }
  if (to === "/invitations") {
    return currentPath.startsWith("/invitations");
  }
  return currentPath === to;
};

function FloatingNavbarDesktop({ links, currentPath }) {
  return (
    <nav className="floating-navbar-desktop" aria-label="Floating desktop navigation">
      <Link to="/" className="floating-navbar-desktop-logo-link">
        <img src={logo} alt="Kazhavda" className="floating-navbar-desktop-logo" />
      </Link>

      <div className="floating-navbar-desktop-links">
        {links.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className={`floating-navbar-desktop-link ${
              isLinkActive(link.to, currentPath) ? "active" : ""
            }`}
          >
            {link.label}
          </Link>
        ))}
      </div>
    </nav>
  );
}

export default FloatingNavbarDesktop;
